import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import ProgressLoader from "../ProgressLoader";
import "./responsive-content-layout.scss";
import { appHelpers } from "../../_helpers";

const ResponsiveContentLayout = ({
  pageTitle,
  actions,
  children,
  requesting,
  height,
  middleContent,
  width,
}) => {
  return (
    <div>
      {requesting && <ProgressLoader message={"Sending Request"} />}
      <Card
        style={{
          borderRadius: "0.5rem 0.5rem 0 0",
          backgroundColor: "rgb(255,255,255)",
          minHeight: height,
        }}
        className="responsive-content-layout p-3 p-md-4"
      >
        <CardHeader
          style={{ background: "transparent", padding: "0.9rem 1.25rem" }}
          className="responsive-header"
        >
          <Row
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
              alignItems: "flex-end",
            }}
            className="pb-2"
          >
            <Col xs="12" md={`${middleContent ? 4 : 6}`}>
              <div className="title-container">
                <h2
                  style={{
                    fontWeight: "700",
                    fontSize: "24px",
                    marginBottom: 0,
                    whiteSpace: "nowrap",
                  }}
                  className="responsive-title"
                >
                  {pageTitle}
                </h2>
               
              </div>
            </Col>
            {middleContent && (
              <Col xs="12" md="3" sm="6" className="mt-2 mt-md-0">
                {middleContent}
              </Col>
            )}

            <Col xs="12" md={`${middleContent ? 5 : 6}`} sm="6" className="mt-2 mt-md-0 text-left text-md-right">
              {actions}
            </Col>
          </Row>
        </CardHeader>
        <CardBody style={{ backgroundColor: "rgba(255,255,255, 0.9)" }} className="responsive-body">
          {children}
        </CardBody>
      </Card>
    </div>
  );
};

export default ResponsiveContentLayout;